import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { DialogContent, DialogTitle } from '@material-ui/core';
import { IdPropType } from '../../../proptypes/basic';
//import { updateEmployee, useEmployee } from '../employeesSlice';
import { updateLocation, useLocation } from '../locationsSlice';
import { attachmentsToFieldValue } from '../../files/utils';
import DocumentsForm from '../../documents/components/DocumentsForm';
import { useDialogControl } from '../../dialogs/components/DialogControlContext';
import { useCallbackRef } from '../../hooks';
import Dialog from '../../dialogs/components/Dialog';
import DialogFormActions from '../../dialogs/components/DialogFormActions';

const LocationSignatureDialog = ({ locationId }) => {
    const ref = useCallbackRef();
    const [location, { loading, initialized }] = useLocation(locationId);

    const { onClose } = useDialogControl();

    const dispatch = useDispatch();

    const initialValues = useMemo(
        () => ({
            documents: attachmentsToFieldValue(location.documents),
        }),
        [location]
    );

    const handleSubmit = useCallback(
        (values) => dispatch(updateLocation(values)).then(onClose),
        [dispatch, onClose]
    );

    return (
        <Dialog>
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Unterschrift Standort</DialogTitle>

            <DialogContent>
                <DocumentsForm
                    name="documents"
                    label="Unterschrift hinzufügen"
                    initialPath="System/locationSignatures"
                    entity={location}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    loading={loading}
                    initialized={initialized}
                    submitRef={ref}
                    max={1}
                />
            </DialogContent>
            <DialogFormActions ref={ref} />
        </Dialog>
    );
};

LocationSignatureDialog.propTypes = {
    locationId: IdPropType.isRequired,
};

LocationSignatureDialog.defaultProps = {};

export default LocationSignatureDialog;
